import {createFeatureSelector} from "@ngrx/store";
import {PmPortalState} from "./index";

export const pmPortalStateFeatureKey = 'pmPortalState';

export const pmPortalStateFeatureSelector = createFeatureSelector<PmPortalState>(
    pmPortalStateFeatureKey
);